import { render } from "./MessageWall.vue?vue&type=template&id=15eec74e&scoped=true"
import script from "./MessageWall.vue?vue&type=script&lang=js"
export * from "./MessageWall.vue?vue&type=script&lang=js"

import "./MessageWall.vue?vue&type=style&index=0&id=15eec74e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15eec74e"]])

export default __exports__